import styled from 'styled-components';

export const StageFooterContainer = styled.div`
    box-sizing: border-box;
    height: var(--desktop-footer-height);
    position: fixed;
    z-index: 2;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 20px 12px;
`;

export const ControlsArea = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    position: relative;
    width: 100%;
`;

export const ParticipantsContainer = styled.div`
    display: contents;
`;

export const StageSurface = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    width: 100%;
    height: 100%;
`;

export const ControlsAreaLeft = styled.div`
    position: absolute;
    left: 0;
`;

export const ControlsAreaRight = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;

    position: absolute;
    right: 0;
`;

export const LoadingAnimation = styled.div`
    align-self: center;
    margin: auto;
`;
